import { useContext, createContext } from "react";

import { CheckoutContextProps } from "src/types/checkout";

// ----------------------------------------------------------------------

export const CheckoutContext = createContext({} as CheckoutContextProps);

export const useCheckoutContext = () => {
  let context = useContext(CheckoutContext);

  if (!context)
    throw new Error("useCheckoutContext must be use inside CheckoutProvider");

  return context;
};
